/* eslint-disable no-nested-ternary */
import dayjs, { Dayjs } from 'dayjs';

import { PersonBookingsObject } from '@/types/person';

export const getDisabledDate = (current: Dayjs, maxDate: string) =>
	(current && current.add(1, 'day') < dayjs().endOf('day')) ||
	(current && current > dayjs(maxDate).add(1, 'day'));

export const getCarAccessDate = (current: Dayjs) =>
	(current && current.add(1, 'day') < dayjs().endOf('day')) ||
	(current && current > dayjs().add(33, 'day'));

export const disabledTime = (now: Dayjs | null) => ({
	disabledHours: () =>
		range(0, 24).splice(0, now?.isToday() ? dayjs().hour() : 0),
	disabledMinutes: () =>
		range(0, 60).splice(
			0,
			now && now.date() !== dayjs().date()
				? 0
				: now && now.hour() === dayjs().hour()
				? dayjs().minute()
				: 0,
		),
	disabledSeconds: () => range(0, 60),
});

export const range = (start: number, end: number) => {
	const result = [];
	for (let i = start; i < end; i++) {
		result.push(i);
	}
	return result;
};

const getMinutes = (object?: PersonBookingsObject | null) =>
	object
		? dayjs(object.end).diff(dayjs(object.start), 'minutes') -
		  dayjs(object.end).diff(dayjs(object.start), 'hours') * 60
		: 0;

export const getDiffHours = (object?: PersonBookingsObject | null) => {
	const minutes = getMinutes(object);
	return minutes === 59
		? dayjs(object?.end).diff(dayjs(object?.start), 'hours') + 1
		: dayjs(object?.end).diff(dayjs(object?.start), 'hours');
};

export const getDiffMinutes = (object?: PersonBookingsObject | null) => {
	const minutes = getMinutes(object);

	return minutes === 59 ? 0 : minutes;
};

export const getNearestDate = (ds: Dayjs | null) =>
	(ds ?? dayjs())
		?.minute(
			(ds ?? dayjs()).minute() === 0
				? 0
				: Math.ceil((ds ?? dayjs()).minute() / 15) * 15,
		)
		.second(0);

export const exclusiveEnd = (end: Date | null): Date => dayjs(end).subtract(1, 'minute').toDate();

export const setNearestDatetoLS = (ds: Dayjs | null) => {
	sessionStorage.setItem('from', JSON.stringify(getNearestDate(ds).toJSON()));
};
